import actions from "./actions"

export default function employeeReducers(state = [], action:{payload: any, type: string}):any{
    switch (action.type){
        case actions.SET_DATA:
            return [...action.payload];
        default:
            return state;
    }
}